import type { OperationFailureReason } from '@mint-lib/datadog';

import {
  type ConnectionOperationContext,
  failConnectionOperation,
  startConnectionOperation,
  succeedConnectionOperation,
} from './connectionOperation.js';

export type ConnectionAddOperationContext = ConnectionOperationContext;

/**
 * Starts the `connection.add` RUM operation when the user submits the add
 * form. See {@link startConnectionOperation} for how it survives the OAuth
 * redirect and stays apart from `connection.reconnect`.
 */
export function startConnectionAddOperation(
  context: ConnectionAddOperationContext,
) {
  startConnectionOperation('connection.add', context);
}

/** Ends the open `connection.add` operation, if any, as succeeded. */
export function succeedConnectionAddOperation() {
  succeedConnectionOperation('connection.add');
}

/** Ends the open `connection.add` operation, if any, as failed. */
export function failConnectionAddOperation(reason: OperationFailureReason) {
  failConnectionOperation('connection.add', reason);
}
